import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Loading from "Components/Loading";
import API_BASE_URL from "Components/API";
import { useTranslation } from "react-i18next";
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "Assets/icons/chevronRight.svg";
const BoardOfDirectors = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    const [data, setData] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const fetchData = async (id) => {
        try {
            if (!id) return;
            setIsLoaded(false);
            const url = `${API_BASE_URL}/AboutUs/GetBoardOfDirectors?BoardOfDirectorPeriodId=${id}&Lang=${currentLang}`;

            const response = await axios.get(url);

            if (response.data.isSuccess) {
                setData(response.data.results || []);                
            } else if (response.data.isFailed) {
                console.warn("Request failed:", response.data.message);
            }
        } catch (error) {
            console.error("Error fetching board of directors periods:", error);
        } finally {
            setIsLoaded(true);
        }
    };
    const fetchBoardOfDirectorsPeriods = async () => {
        try {
            const url = `${API_BASE_URL}/AboutUs/GetBoardOfDirectorsPeriods?Lang=${currentLang}`;
            const response = await fetch(url);
            const data = await response.json();
            if (data.isSuccess) {
                setSelectedPeriod(data.results[0]?.id);
                fetchData(data.results[0]?.id)
            } else if (data.isFailed) {
            }
        } catch (error) {
            console.error('Error fetching board of directors periods:', error);
        }
        finally {
        }
    };
    useEffect(() => {
        fetchBoardOfDirectorsPeriods()
        
    }, [currentLang]);

    return (
        <div className="megaMenuContent">
            {
                isLoaded ?
                    <>
                        <div className="row">
                            { data.map((item) => (
                                <div className="col-md-3 col-sm-6 col-xs-12" key={item.id}>
                                    <div className="boardOfDirectors text-center mb-1">
                                        <div className="boardImg">
                                            <img src={"data:image/png;base64," + item.image} className="boardOfDirectors-img w-100" alt={item.firstName + " " + item.lastName} />
                                        </div>
                                        <div className="director pt-5 pb-2 px-1">
                                            <div className="boardOfDirectors-name text-blue">{item.firstName}</div>
                                            <div className="d-flex justify-content-between align-items-center mx-3 boardLine">
                                                <small className="boardOfDirectors-position">{item.lastName}</small>
                                                <small className="boardOfDirectors-position">{item.position}</small>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="col-12 text-start mt-2">
                            <a href="/BoardOfDirectors" target="_blank" className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1" >
                                {t("read_more")}
                                <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                                    {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}
                                </span>
                            </a>
                        </div>
                    </>
                    :
                    <Loading />
            }
        </div>
    );
};

export default BoardOfDirectors;
